import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { canViewDriverDirectory, getDriverDirectory } from '../../services/DriverDirectory';

export const useDriverDirectory = (params, authorization = { enabled: false }) => {
  const user = useSelector((state) => state.user.user);
  const enabled = user?.id != null && canViewDriverDirectory(user) && authorization.enabled;
  const query = useQuery(['driver-directory', user?.id, authorization.revision, params], () => {
    if (!enabled) throw new Error('Select and apply an authorized business scope first.');
    return getDriverDirectory(params);
  }, {
    enabled,
    cacheTime: 0,
    staleTime: 0,
    keepPreviousData: false,
    retry: false,
    refetchOnWindowFocus: false,
  });
  // react-query v2 calls this updatedAt (v3 renamed it dataUpdatedAt).
  return { ...query, data: enabled ? query.data : undefined, dataUpdatedAt: query.updatedAt };
};